<template>
  <footer id="contact" class="bg-gray-100 dark:bg-gray-900 py-8 px-6 mt-8">
    <div class="max-w-7xl mx-auto text-center">
      <h2 class="text-2xl font-semibold text-gray-800 dark:text-gray-200 mb-4">
        Connect with Me
      </h2>
      <p class="text-gray-600 dark:text-gray-400 text-sm mb-6">
        Let's collaborate! Feel free to reach out on my social platforms.
      </p>

      <!-- Social Links -->
      <div class="flex justify-center space-x-6">
        <a
            href="https://www.linkedin.com/in/ranahamza11/"
            target="_blank"
            class="text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-500 transition"
            aria-label="LinkedIn"
        >
          <i class="fab fa-linkedin text-2xl"></i>
        </a>
        <a
            href="mailto:ranahamzanaeem11@gmail.com"
            class="text-gray-700 dark:text-gray-300 hover:text-red-500 transition"
            aria-label="Email"
        >
          <i class="fas fa-envelope text-2xl"></i>
        </a>
      </div>

      <!-- Copyright -->
      <div class="mt-6 text-gray-500 dark:text-gray-400 text-sm">
        &copy; {{ new Date().getFullYear() }} MHN. All rights reserved.
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "ContactSection",
};
</script>

<style scoped>
/* Add smooth hover effect */
i {
  transition: transform 0.3s ease-in-out;
}
i:hover {
  transform: scale(1.1);
}
</style>
